export default __webpack_public_path__ + "static/media/pdf img.72c301e6.svg";